<template>
  <main id="check_car_info" class="check_car_info common_base">
    <el-dialog title="车辆信息" :visible.sync="vehicle.showVehicleCheckDialog">
      <section>
        <el-row class="border-left-title">基础信息</el-row>
        <el-base-info :list="baseInfoList" />
        <el-row class="border-left-title">照片信息</el-row>
        <section class="check_car_info_photo_info">
          <el-row>
            <el-col
              :span="item.span || 12"
              v-for="(item, index) in imageConfig.imageList"
              :key="index"
            >
              <el-image-uploader ref="imageUpload" :imageObj="item" />
            </el-col>
          </el-row>
        </section>
        <el-row
          v-if="vehicle.vehicleDetail.contracts.length"
          class="border-left-title"
          >合同信息</el-row
        >
        <section
          class="contract_info"
          v-if="vehicle.vehicleDetail.contracts.length"
        >
          <el-contract-card
            v-for="(item, index) in contractList"
            :key="index"
            :detail="item"
          />
        </section>
      </section>
    </el-dialog>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import * as constant from '../../constant/common-type.ts'
import commonImageUploader from '../../components/console-common/common-image-uploader.vue'
import contractCard from '../../components/console-common/contract-board.vue'
import commonBaseInfo from '../../components/console-common/common-base-info.vue'
import moment from 'moment'
export default {
  created() {
    this.getContractList()
    this.getVehicleList()
    this.getImageList()
  },
  components: {
    'el-image-uploader': commonImageUploader,
    'el-contract-card': contractCard,
    'el-base-info': commonBaseInfo,
  },
  data() {
    return {
      contractList: [],
      baseInfoList: [],
      imageConfig: {},
    }
  },
  computed: {
    ...mapState({
      vehicle: (state) => state.vehicle,
    }),
  },
  methods: {
    getImageList() {
      this.imageConfig = {
        imageList: [
          {
            title: '车辆照片',
            span: 24,
            fileList: this.vehicle.vehicleDetail.vehiclePhotos,
            key: 'vehiclePhotos',
            type: 'check',
            disabled: true,
          },
          {
            title: '网约车证',
            key: 'onlineLicensePhotos',
            span: 12,
            fileList: this.vehicle.vehicleDetail.onlineLicensePhotos,
            type: 'check',
            disabled: true,
          },
          {
            title: '行驶证照片',
            type: 'check',
            disabled: true,
            key: 'drivingLicensePhotos',
            fileList: this.vehicle.vehicleDetail.drivingLicensePhotos,
          },
        ],
      }
    },
    getVehicleList() {
      this.baseInfoList = [
        {
          label: '车牌号',
          val: this.vehicle.vehicleDetail.licensePlateNumber,
        },
        {
          label: '当前签约司机',
          val:
            this.vehicle.vehicleDetail.driverName > 10
              ? `${this.vehicle.vehicleDetail.driverName.substring(0, 10)}...`
              : this.vehicle.vehicleDetail.driverName,
        },
        {
          label: '车架号',
          val:
            this.vehicle.vehicleDetail.vehicleIdentificationNumber > 17
              ? `${this.vehicle.vehicleDetail.vehicleIdentificationNumber.substring(
                  0,
                  17
                )}...`
              : this.vehicle.vehicleDetail.vehicleIdentificationNumber,
        },
        {
          label: '发动机号',
          val:
            this.vehicle.vehicleDetail.engineNumber > 12
              ? `${this.vehicle.vehicleDetail.engineNumber.substring(0, 12)}...`
              : this.vehicle.vehicleDetail.engineNumber,
        },
        {
          label: '车辆型号',
          val:
            this.vehicle.vehicleDetail.vehicleModel.length > 12
              ? `${this.vehicle.vehicleDetail.vehicleModel.substring(0, 12)}...`
              : this.vehicle.vehicleDetail.vehicleModel,
        },
        {
          label: '车辆用途',
          val:
            this.vehicle.vehicleDetail.purpose === 'OTHER'
              ? this.vehicle.vehicleDetail.purposeText
              : constant.purposeName[this.vehicle.vehicleDetail.purpose],
        },
        {
          label: '车辆状态',
          val: constant.vehicleStatusName[this.vehicle.vehicleDetail.status],
        },
        {
          label: '油电性质',
          val: constant.poweredName[this.vehicle.vehicleDetail.powered],
        },
        {
          label: '颜色',
          val: constant.colorName[this.vehicle.vehicleDetail.color],
        },
        {
          label: '所属公司',
          span: 24,
          val: this.vehicle.vehicleDetail.subjection,
        },
        {
          label: '经办人',
          span: 24,
          val: this.vehicle.vehicleDetail.operator,
        },
        {
          label: '购置日期',
          val: this.vehicle.vehicleDetail.purchaseTime
            ? moment(this.vehicle.vehicleDetail.purchaseTime).format(
                'YYYY-MM-DD'
              )
            : '--',
        },
        {
          label: '上牌日期',
          val: this.vehicle.vehicleDetail.licenseTime
            ? moment(this.vehicle.vehicleDetail.licenseTime).format(
                'YYYY-MM-DD'
              )
            : '--',
        },
        {
          label: '备注',
          span: 24,
          val: this.vehicle.vehicleDetail.remark,
        },
      ]
    },
    getContractList() {
      if (!this.vehicle.vehicleDetail.contracts.length) return
      this.vehicle.vehicleDetail.contracts.forEach((item) => {
        let obj = {
          orderNo: '',
          status: '',
          list: [],
        }
        obj.orderNo = item.contractCode
        obj.status = item.contractProcess
        // obj.list.push(item)
        obj.list = [
          {
            key: '司机姓名',
            val: item.driverName,
          },
          {
            key: '车牌号',
            val: item.plateNumber,
            push: 3,
          },
          {
            key: '注册手机号',
            val: item.driverMobile,
            span: 24,
          },
          {
            key: '业务模式',
            val: constant.leaseMode[item.leaseMode],
            span: 12,
          },
          {
            key: '租金',
            val: `￥${this.$utils.toYuan(item.monthlyPayment)}`,
            push: 3,
          },
          {
            key: '合同有效期',
            val: `${moment(item.startTime).format('YYYY-MM-DD')} 至 ${moment(
              item.endTime
            ).format('YYYY-MM-DD')}`,
            span: 24,
          },
        ]
        this.contractList.push(obj)
      })
    },
  },
}
</script>

<style lang="stylus">
#check_car_info
  .contract-board
    min-width 400px
    border none
    margin-bottom 8px
</style>
